import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as addressReducer from '../../reducers/addressReducer';
import { setLocalProps } from '../../helpers/localStorage';
import * as modal from '../../reducers/modalReducer';
import CloseIcon from '../CloseIcon';
import { THIRD_COLOR } from '../../config/colors';
import {isPickup, isDelivery, isExpress, isShippingForm as isShippingFormSelector} from '../../selectors/configSelectors';
import './style.css';
import {isKioskSelector} from '../../selectors/viewSelectors';
import {formatAptNum} from '../../helpers/addressHelper';
import { toBool } from '../../reducers/configReducer';

const locationIcon = process.env.PUBLIC_URL + '/assets/img/icons/location.svg';
const locationIconWhite = process.env.PUBLIC_URL + '/assets/img/icons/location-white.svg';

const styles = {
  closeIconWhite: {
    color: "#fff"
  },
  closeIconGrey: {
    color: THIRD_COLOR
  }
}
class AddressBar extends Component {
  state = {
    question: false
  }

  shouldComponentUpdate(nextProps) {
    return !nextProps.isKiosk;
  }

  getAddressBarTextColor = () => this.props.addressBarTextColor ? `#${this.props.addressBarTextColor}` : '#fff';

  getAddress = (prop) => {
    const { isDelivery, currentAddress  } = this.props;
    // const location = this.state.question ? locationIconWhite : locationIcon;
    if (!this.props.currentAddress) {
      const {expressAvailable, instoreAvailable, deliveryAvailable} = this.props;
      const pickupLocation = this.props.pickupLocation ? this.props.pickupLocation : '';
      const dispensaryName = this.props.dispensaryName ? this.props.dispensaryName : '';
      const question = this.props.addressQuestion ? this.props.addressQuestion : 'Hey! Quick question: Pick up or delivery?';
      const message = (instoreAvailable) && !(expressAvailable) && !(deliveryAvailable) ?
        `Pick up available at ${dispensaryName} in ${pickupLocation}` : question;
      return <span className="question-str" style={{color: this.getAddressBarTextColor()}}>{message}</span>;
    } else if (isDelivery) {
      const address = [currentAddress.street, ', ', currentAddress.city, ', ', currentAddress.state, ' ', currentAddress.zip, formatAptNum(currentAddress)];
      return (
        <span className="address-str">
          <span className="address-type" style={{color: this.getAddressBarTextColor()}}>DELIVERY TO: </span>
          <span className="address-text" style={{color: this.getAddressBarTextColor()}}> { address.join('')}</span>
        </span>
      )
    } else {
      const address = [currentAddress.street, ', ', currentAddress.city, ', ', currentAddress.state, ' ', currentAddress.zip];
      return (
        <span className="address-str"><span className="address-type" style={{color: this.getAddressBarTextColor()}}>PICK UP AT: </span>
        <span className="address-text" style={{color: this.getAddressBarTextColor()}}> { address.join('')} </span></span>
      )
    }
  }

  /* is there address selected */
  isAddress = () => {
    return this.props.currentAddress !== '';
  }

  handleCloseClick = (e) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    this.props.hideAddressBar();
    setLocalProps({isAddressBarOpened: false});
  }

  handleBackBtnClick = (e) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    this.props.onBackBtnClick();
  }

  handleAddressClick = () => {
    this.props.openShippingForm();
  }

  getBackBtnColor = () => {
    if (this.isAddress()) {
      return this.props.secondaryColor
    } else {
      return "FFF"
    }
  }

  render() {
    const {isShippingForm} = this.props;
    const closeIconStyle = this.isAddress() ? styles.closeIconGrey : styles.closeIconWhite;
    const location = !this.isAddress() ? locationIconWhite : locationIcon;
    // const close = !this.isAddress() ? closeIconWhite : closeIcon;
    const addressIconStyle = { display: !this.props.isBackBtn ? '':'none' };
    // const addressBarStyle = {borderBottom: '1px solid', borderBottomColor: '#'+this.props.primaryColor};
    const addressClasses = !this.isAddress() ? 'question' : '';
    const addressStyle = this.isAddress() ? {
      backgroundColor: this.props.addressBarColor ? `#${this.props.addressBarColor}` : '#C1DB7E',
      color: this.props.addressBarTextColor ? `#${this.props.addressBarTextColor}` : '#fff'
    } : {color: '#fff'};

    if (!isShippingForm) return <div />;

    return (
      <div>
        { this.props.isAddressBarOpened &&
          <div onClick={this.handleAddressClick} className={"address-bar " + addressClasses} style={addressStyle}>
            <div className="address-wrapper">
              <img className="address-bar-location" style={addressIconStyle} src={location} alt="Location"/> {this.getAddress()}
            </div>
            <CloseIcon onClick={(e) => this.handleCloseClick(e)} style={closeIconStyle}/>
          </div>
        }
      </div>
    )
  }
}

AddressBar.propTypes = {
  isShippingForm: PropTypes.bool.isRequired
};

const mapStateToProps = (state) => {
  return {
    secondaryColor: state.config.secondaryColor,
    primaryColor: state.config.primaryColor,
    isAddressBarOpened: addressReducer.isAddressBarOpened(state),
    isDelivery: addressReducer.isDelivery(state),
    currentAddress: addressReducer.currentAddress(state),
    deliveryAvailable: toBool(isDelivery(state)),
    instoreAvailable: toBool(isPickup(state)),
    expressAvailable: toBool(isExpress(state)),
    dispensaryName: state.config.DISPENSARY_FULL_NAME,
    addressBarColor: state.config.ECOMMERCE_ADDRESSBAR_COLOR,
    addressBarTextColor: state.config.ECOMMERCE_ADDRESSBAR_TEXT_COLOR,
    addressQuestion: state.config.ECOMMERCE_ADDRESSBAR_QUESTION,
    pickupLocation: state.config.pickupLocation,
    isShippingForm: isShippingFormSelector(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    openShippingForm: () => dispatch(modal.openModal({
      modalType: 'SHIPPING_FORM',
      modalProps: {}
    })),
    hideAddressBar: () => dispatch(addressReducer.hideAddressBar())
  };
};

export default connect(mapStateToProps, mapDispatchToProps) (AddressBar);



// WEBPACK FOOTER //
// ./src/components/AddressBar/AddressBar.jsx